import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTimelinesItemChangeHistory } from 'scenes/Timelines/services/getTimelinesItemChangeHistory';

export const loadTimelineItemChangeHistory = createAsyncThunk(
  'timelines/loadTimelineItemChangeHistory',
  async (itemId) => {
    const response = await getTimelinesItemChangeHistory(itemId);

    return response;
  }
);
